<template>
  <el-dialog
    v-model="visible"
    width="800px"
    transition="dialog-bounce"
    :show-close="false"
    align-center
    lock-scroll
    :close-on-click-modal="false"
  >
    <template #header="{ close }">
      <div class="dialog-header">
        <el-icon :size="20" @click="close" class="close-btn">
          <Close />
        </el-icon>
        <h2>评价订单</h2>
      </div>
    </template>
    <div v-if="good_data" class="dialog-content">
      <template v-for="(item, index) in good_data" :key="index">
        <div class="evaluate_n1">
          <div class="n1_letf">
            <el-image :src="item.thumb" :preview-src-list="[item.thumb]" fit="cover" />
          </div>
          <div class="n1_right">
            <div class="n1_right_sx">
              <text class="n1_sx_desc">描述相符</text>
              <el-rate v-model="item.describe_num" />
            </div>
            <div class="n1_good_title">{{ item.title }}</div>
          </div>
        </div>
        <div class="evaluate_n2">
          <textarea
            v-model="item.content"
            placeholder="分享您的购物心得"
            class="textarea"
            placeholder-style="color:#333;font-size:26upx"
          ></textarea>
        </div>
        <div class="evaluatee_n3">
          <div class="n3_upload">
            <UploadImage v-model:files="item.images" />
          </div>
        </div>
      </template>
      <div class="evaluate_btn flex-center">
        <div class="evaluate_sumbit flex-center" @click="sumbitFun">发表评论</div>
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
  import { ref, defineExpose, unref, defineEmits } from 'vue'
  import { ElMessage } from 'element-plus'
  import { submitComment, waitCommentOrderGoodsList } from '@/api/user'
  import UploadImage from './UploadImage.vue'

  const emits = defineEmits(['success'])

  const visible = ref(false)

  const good_data = ref()

  const show = async id => {
    try {
      const result = await waitCommentOrderGoodsList(id)
      if (!result) return
      good_data.value = result.map(i => ({ ...i, describe_num: 5, content: '', images: [] }))
      visible.value = true
    } catch (error) {
      ElMessage.error(error)
    }
  }

  const sumbitFun = async () => {
    try {
      const data = unref(good_data).map(i => ({
        orderId: i.orderId,
        orderGoodsId: i.id,
        score: i.describe_num * 20, // 转为百分制
        content: i.content,
        images: i.images
      }))
      if (data.some(i => !i.content)) return ElMessage.error('评论内容不能为空')
      await submitComment({ items: data })
      ElMessage.success('提交成功')
      visible.value = false
      emits('success')
    } catch (error) {
      ElMessage.error(error)
    }
  }

  defineExpose({ show })
</script>

<style lang="scss" scoped>
  .dialog-header {
    position: relative;

    h2 {
      font-size: 20px;
      font-weight: 700;
      text-align: center;
    }

    .close-btn {
      position: absolute;
      right: 0;
      cursor: pointer;
    }
  }

  .dialog-content {
    .evaluate_n1 {
      width: 100%;
      height: auto;
      border-bottom: 1px solid #d9d9d9;
      padding: 10px;
      background: #ffffff;
      margin-top: 10px;
      display: flex;
      align-items: center;

      .n1_letf {
        width: 100px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .n1_right {
        margin-left: 10px;

        .n1_right_sx {
          display: flex;
          align-items: center;
          margin-bottom: 6px;

          .n1_sx_desc {
            margin-right: 15px;
          }
        }

        .n1_good_title {
          width: 250px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          line-clamp: 2;
          overflow: hidden;
          word-break: break-all;
          white-space: normal;
        }
      }
    }

    .evaluate_n2 {
      background: #fff;
      padding-top: 10px;
      border-bottom: 1px solid #d9d9d9;

      .textarea {
        width: 96%;
        margin: 0 auto;
        text-align: left;
        font-size: 26upx;
        display: block !important;
        height: 100px;
        padding-left: 5px;
      }
    }

    .evaluatee_n3 {
      width: 100%;
      height: auto;
      background: #ffffff;
      padding: 20rpx;

      .n3_upload {
        width: 100%;
        height: 50px;
        display: flex;

        .imgItem {
          margin-right: 10px;
          width: 50px;
          height: 50px;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #f5f5f5;
          position: relative;
          .del {
            position: absolute;
            right: -5px;
            top: -5px;
            z-index: 1;
          }
        }

        img {
          width: 50px;
          height: 100%;
        }

        .upload_img {
          border: 1px solid #e8e8e8;
        }
      }
    }

    .evaluate_n4 {
      width: 100%;
      height: auto;
      padding: 10px 20px 25px;
      background: #fff;
      margin-top: 10px;

      .n4_list {
        display: flex;
        align-items: center;

        .n4_desc {
          margin-right: 10px;
        }
      }

      .logistic {
        margin-top: 10px;
      }
    }

    .evaluate_btn {
      width: 100%;
      height: auto;
      margin-top: 40px;
      display: flex;
      justify-content: center;

      .evaluate_sumbit {
        width: 330px;
        height: 46px;
        line-height: 46px;
        background: #e4393c;
        font-size: 16px;
        border-radius: 8px;
        color: #fff;
        margin-bottom: 20px;
        text-align: center;
        cursor: pointer;
        user-select: none;
      }
    }
  }
</style>
